import React from "react";
// import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons/faUserCircle";
// import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { motion } from "framer-motion";
import AboutMission from "../assets/About/mission.png";
import ceoImage from "../assets/About/Davin.png";
import emilyImage from "../assets/About/Emily.png";
import JamieImage from "../assets/About/Jamie.png";
import CalumImage from "../assets/About/Calum.png";
import HeadTile from "../assets/About/profile_head.png";
import "./About.css";
// TODO: For further performance, consider splitting About.css into smaller CSS modules or using CSS-in-JS/code-splitting for above-the-fold and below-the-fold styles.
import { Helmet } from "react-helmet-async";

interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: string | null;
  linkedin: string;
  bio: string;
}

const About = () => {
  // const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const teamMembers: TeamMember[] = React.useMemo(
    () => [
      {
        id: 1,
        name: "Davin Browne",
        role: "Chief Executive Officer",
        image: ceoImage,
        linkedin: "https://bit.ly/3G2mNJb",
        bio: "Leads Apollo Financial Services with a client-first philosophy, ensuring our financial solutions meet the highest standards of excellence and integrity.",
      },
      {
        id: 2,
        name: "Daryll Browne",
        role: "Chief Operating Officer",
        image: HeadTile,
        linkedin:
          "https://www.linkedin.com/company/apollo-financial-services-limited/posts/?feedView=all",
        bio: "Daryll Browne is the Chief Operations Officer at Selenean Capital. Prior to Selenean Capital, Browne was the chief operations officer at Apollo Financial Services leading the Ireland/UK property and renewables portfolio. He is also a fully qualified financial advisor who specialised in providing financial advice to HNW clients.",
      },
      {
        id: 3,
        name: "Emily Corcoran",
        role: "Head of Compliance",
        image: emilyImage,
        linkedin: "https://bit.ly/3R5XMPI",
        bio: "Emily Corcoran brings over a decade of experience in the financial services industry, with deep expertise in compliance and fraud prevention. She has held key roles in the Fraud Department at Bank of Ireland and on the Compliance Team at Brokers Ireland. For the past six years, she has served as Compliance Officer at Apollo, where she leads the firm’s regulatory strategy and fosters a strong culture of compliance. In addition, Emily contributes to shaping industry standards as a member of the Compliance Board at Brokers Ireland, playing an active role in the development of best practices across the sector.",
      },
      {
        id: 4,
        name: "Adrian Ryan",
        role: "Financial Broker",
        image: HeadTile,
        linkedin:
          "https://www.linkedin.com/company/apollo-financial-services-limited/posts/?feedView=all",
        bio: "Oversees daily operations and ensures smooth coordination between teams, helping Apollo deliver efficient and client-focused financial services.",
      },
      {
        id: 5,
        name: "Jamie Pim",
        role: "Financial Broker",
        image: JamieImage,
        linkedin: "https://bit.ly/4lii5Hn",
        bio: "Jamie is a Financial Advisor specialising in personalised financial planning, wealth management, and retirement strategies. Jamie helps individuals and businesses achieve their financial goals with tailored advice on investments, life cover, and pensions Jamie holds a QFA designation and stays current with industry trends to provide the best solutions for clients.",
      },
      {
        id: 6,
        name: "Calum McCoy",
        role: "Financial Broker",
        image: CalumImage,
        linkedin:
          "https://www.linkedin.com/company/apollo-financial-services-limited/posts/?feedView=all",
        bio: "Specializing in pension planning and retirement strategies, Calum helps clients navigate complex financial decisions with clarity and confidence.",
      },
      {
        id: 7,
        name: "Rían Costigan",
        role: "Head of Marketing",
        image: HeadTile,
        linkedin: "https://bit.ly/426wcIk",
        bio: "Rían leads marketing at Apollo Financial, driving growth and brand visibility through innovative, data-driven strategies. Rían is dedicated to enhancing customer experiences.",
      },
      {
        id: 8,
        name: "Arielle Nunez",
        role: "Office Administrator",
        image: HeadTile,
        linkedin:
          "https://www.linkedin.com/company/apollo-financial-services-limited/posts/?feedView=all",
        bio: "The backbone of our operations, Arielle ensures seamless client experiences and efficient coordination across all departments.",
      },
    ],
    []
  );

  const itemVariants = React.useMemo(
    () => ({
      hidden: { y: 20, opacity: 0 },
      visible: {
        y: 0,
        opacity: 1,
        transition: {
          duration: 0.6,
        },
      },
    }),
    []
  );

  const renderTeamImage = React.useCallback(
    (imgSrc: string | null, altText: string) => {
      if (imgSrc) {
        return (
          <img
            src={imgSrc}
            alt={`${altText} at Apollo Financial Services`}
            className="team-img"
          />
        );
      }
      return (
        <div className="team-img-placeholder" aria-label={`${altText} profile`}>
          <FontAwesomeIcon icon={faUserCircle} size="8x" />
        </div>
      );
    },
    []
  );

  // const openModal = (member: TeamMember) => {
  //   setSelectedMember(member);
  //   setIsModalOpen(true);
  //   document.body.style.overflow = 'hidden';
  // };

  // const closeModal = () => {
  //   setIsModalOpen(false);
  //   document.body.style.overflow = 'auto';
  // };

  return (
    <div className="about-container">
      <Helmet>
        <title>
          About - Apollo Financial Services | Advisors in Duleek, Ireland
        </title>
        <link rel="canonical" href="https://www.apollofinancial.ie/about/" />
        <meta
          name="description"
          content="Meet our team of qualified financial advisors. Apollo Financial Services provides personalized wealth management solutions across Ireland."
        />
        <meta
          name="keywords"
          content="financial advisor Duleek, financial planner Duleek, wealth management Duleek, investment advisor Duleek, retirement planning Duleek, financial consultant Duleek, personal finance advisor Duleek, financial planning services Duleek, independent financial advisor Duleek, fiduciary financial advisor Duleek, financial advisor Meath, financial planner Meath, wealth management Meath, investment advisor Meath, retirement planning Meath, financial consultant Meath, personal finance advisor Meath, financial planning services Meath, independent financial advisor Meath, fiduciary financial advisor Meath, financial advisor Dublin, financial planner Dublin, wealth management Dublin, investment advisor Dublin, retirement planning Dublin, financial consultant Dublin, personal finance advisor Dublin, financial planning services Dublin, independent financial advisor Dublin, fiduciary financial advisor Dublin, financial advisor Cork, financial planner Cork, wealth management Cork, investment advisor Cork, retirement planning Cork, financial consultant Cork, personal finance advisor Cork, financial planning services Cork, independent financial advisor Cork, fiduciary financial advisor Cork, financial advisor Galway, financial planner Galway, wealth management Galway, investment advisor Galway, retirement planning Galway, financial consultant Galway, personal finance advisor Galway, financial planning services Galway, independent financial advisor Galway, fiduciary financial advisor Galway"
        />
        <meta
          property="og:title"
          content="About Apollo Financial Services | Trusted Financial Advisors"
        />
        <meta
          property="og:description"
          content="Get to know our team of Central Bank-regulated financial experts serving Duleek and all of Ireland."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.apollofinancial.ie/about/"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "About Apollo Financial Services",
            description: "Professional financial advisory team",
            url: "https://www.apollofinancial.ie/about/",
            publisher: {
              "@type": "Organization",
              name: "Apollo Financial Services",
              logo: "https://www.apollofinancial.ie/src/assets/Home/logo2.jpg",
            },
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.apollofinancial.ie",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "About Us",
                item: "https://www.apollofinancial.ie/about/",
              },
            ],
            employee: teamMembers.map((member) => ({
              "@type": "Person",
              name: member.name,
              jobTitle: member.role,
              url: member.linkedin,
            })),
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.apollofinancial.ie/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "About Us",
                item: "https://www.apollofinancial.ie/about/",
              },
            ],
          })}
        </script>
      </Helmet>
      {/* About Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>Empowering Your Financial Future</h1>
          <p>
            At <strong>Apollo Financial Services</strong>, we help individuals,
            businesses, and families
            <strong> achieve financial security </strong> with expert advice,
            strategic planning, and innovative solutions.
          </p>
          <a href="/contact/#get-in-touch" className="cta-button">
            Get Started
          </a>
        </div>
      </section>

      {/* Our Mission */}
      <section className="about-mission">
        <div className="mission-content">
          <h2>Our Mission</h2>
          <p>
            Our mission is to provide{" "}
            <strong>comprehensive financial strategies</strong> that empower you
            to
            <strong> build, manage and grow </strong> your wealth, as we strive
            to empowering you to achieve financial freedom with the support of
            our advisors. {/* <strong>Financial Advisor</strong>. */}
          </p>
        </div>
        <div className="mission-image">
          <img src={AboutMission} alt="Our Mission" />
        </div>
      </section>

      <section className="about-team">
        <h2>Meet Team Apollo</h2>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.id}
              className="team-member"
              variants={itemVariants}
              whileHover={{ y: -5, boxShadow: "0 10px 25px rgba(0,0,0,0.1)" }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              {renderTeamImage(member.image, member.name)}
              <span style={{ fontWeight: "700", fontSize: "1rem" }}>
                {member.name}
              </span>
              <p className="role engineering">{member.role}</p>

              <div className="about-social-icons">
                {/* <button 
                className="read-bio-button"
                onClick={() => openModal(member)}
              >
                Read Bio
              </button> */}
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Connect with ${member.name} on LinkedIn`}
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* {isModalOpen && selectedMember && (
        <div className="bio-modal-overlay" onClick={closeModal}>
          <div 
            className="bio-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-modal-button" onClick={closeModal}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="modal-header">
              {selectedMember.image ? (
                <img src={selectedMember.image} alt={selectedMember.name} className="modal-image" />
              ) : (
                <div className="modal-image-placeholder">
                  <FontAwesomeIcon icon={faUserCircle} size="6x" />
                </div>
              )}
              <div className="modal-header-text">
                <h3>{selectedMember.name}</h3>
                <p className="modal-role">{selectedMember.role}</p>
              </div>
            </div>
            <div className="modal-bio">
              <p>{selectedMember.bio}</p>
            </div>
            <div className="modal-footer">
              <a 
                href="/contact/#get-in-touch"
                rel="noopener noreferrer"
                className="modal-linkedin-button"
              >
                Get in Touch
              </a>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default About;
